export enum NoticesMutationTypes {
    RESET = "RESET",
    SET_NOTICES = "SET_NOTICES"
}
